module.exports = __webpack_public_path__ + "static/condo_prevPage-84fc116485e0f2a9fe9f495127de321a.jpg";